import { avgEngagementOnImpressionsHistoryConfig } from '@/lib/analytics/charts/pinterest/avgEngagementOnImpressionsHistory';
// Charts
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/pinterest/avgEngagementRateHistory';
import { bestTimeToPostConfig } from '@/lib/analytics/charts/pinterest/bestTimeToPost';
import { clicksHistoryConfig } from '@/lib/analytics/charts/pinterest/clicksHistory';
import { commentsHistoryConfig } from '@/lib/analytics/charts/pinterest/commentsHistory';
import { outboundClicksHistoryConfig } from '@/lib/analytics/charts/pinterest/outboundClicksHistory';
import { reactionsHistoryConfig } from '@/lib/analytics/charts/pinterest/reactionsHistory';
import { savesHistoryConfig } from '@/lib/analytics/charts/pinterest/savesHistory';
import { videoViewsHistoryConfig } from '@/lib/analytics/charts/pinterest/videoViewsHistory';
import { avgClicksPerPinConfig } from '@/lib/analytics/kpis/pinterest/avgClicksPerPin';
import { avgCommentsPerPinConfig } from '@/lib/analytics/kpis/pinterest/avgCommentsPerPin';
import { avgEngagementOnImpressionsConfig } from '@/lib/analytics/kpis/pinterest/avgEngagementOnImpressions';
import { avgEngagementRateOnImpressionsConfig } from '@/lib/analytics/kpis/pinterest/avgEngagementRateOnImpressions';
import { avgEngagementRatePerPinConfig } from '@/lib/analytics/kpis/pinterest/avgEngagementRatePerPin';
import { avgOutboundClickRatePerPinConfig } from '@/lib/analytics/kpis/pinterest/avgOutboundClickRatePerPin';
import { avgOutboundClicksPerPinConfig } from '@/lib/analytics/kpis/pinterest/avgOutboundClicksPerPin';
import { avgReactionsPerPinConfig } from '@/lib/analytics/kpis/pinterest/avgReactionsPerPin';
import { avgSavesPerPinConfig } from '@/lib/analytics/kpis/pinterest/avgSavesPerPin';
import { avgVideoViewsPerPinConfig } from '@/lib/analytics/kpis/pinterest/avgVideoViewsPerPin';
import { clicksConfig } from '@/lib/analytics/kpis/pinterest/clicks';
import { outboundClicksConfig } from '@/lib/analytics/kpis/pinterest/outboundClicks';
import { reactionsConfig } from '@/lib/analytics/kpis/pinterest/reactions';
import { savesConfig } from '@/lib/analytics/kpis/pinterest/saves';
import { totalCommentsConfig } from '@/lib/analytics/kpis/pinterest/totalComments';
// Kpis
import { totalEngagementConfig } from '@/lib/analytics/kpis/pinterest/totalEngagement';
import { totalVideoViewsConfig } from '@/lib/analytics/kpis/pinterest/totalVideoViews';
// Media Widgets
import { mostEngagingPinsConfig } from '@/lib/analytics/widget/pinterest/mostEngagingPinsConfig';
import { SIZE_25, SIZE_33 } from '@/lib/gridElements/size';

export const EngagementPinterest = [
    { ...avgEngagementRatePerPinConfig, size: SIZE_25 },
    avgEngagementOnImpressionsConfig,
    { ...avgEngagementRateOnImpressionsConfig, size: SIZE_25 },
    { ...totalEngagementConfig, size: SIZE_25 },

    avgEngagementRateHistoryConfig,
    avgEngagementOnImpressionsHistoryConfig,

    mostEngagingPinsConfig,

    { ...reactionsConfig, size: SIZE_25 },
    avgReactionsPerPinConfig,
    totalCommentsConfig,
    avgCommentsPerPinConfig,

    savesConfig,
    avgSavesPerPinConfig,
    { ...clicksConfig, size: SIZE_25 },
    avgClicksPerPinConfig,

    { ...outboundClicksConfig, size: SIZE_33 },
    avgOutboundClicksPerPinConfig,
    avgOutboundClickRatePerPinConfig,

    reactionsHistoryConfig,
    commentsHistoryConfig,

    savesHistoryConfig,
    clicksHistoryConfig,

    outboundClicksHistoryConfig,

    bestTimeToPostConfig,

    totalVideoViewsConfig,
    avgVideoViewsPerPinConfig,

    videoViewsHistoryConfig
];

export const requestPinterestParams = [
    [
        'engagement',
        'average_engagement_rate_per_pin',
        'average_engagement_on_impressions',
        'average_engagement_rate_on_impressions',
        'reactions',
        'average_reactions_per_pin',
        'comments',
        'average_comments_per_pin',
        'reactions_history',
        'comments_history',
        'best_time_to_post'
    ],
    [
        'average_engagement_rate_history',
        'average_engagement_on_impressions_history',
        'pin_clicks',
        'average_clicks_per_pin',
        'outbound_clicks',
        'average_outbound_clicks_per_pin',
        'average_outbound_click_rate_per_pin',
        'pin_saves',
        'average_saves_per_pin',
        'saves_history',
        'clicks_history',
        'outbound_clicks_history',
        'video_views',
        'average_video_views_per_pin',
        'video_views_history'
    ]
];
